<template>
  <div class="sort">
    <span class="sort__container">
      <select v-model="sortParam" v-on:change="sortResults($event)" v-bind:disabled="loading.state" class="sort__container--select">
        <option v-for="param in $lang.sorting.params" v-bind:value="param.val" class="sort__container--option">{{ param.name }}</option>
      </select>
    </span>
  </div>
</template>

<script>
// load shared methods from sorting module
import sortResults from './../../scripts/modules/sorting'
import { mapGetters } from 'vuex'

export default {
  name: 'sort',
  data() {
    return {
    }
  },
  methods: {
    sortResults: function(event) {
      return sortResults(event.target.value)
    }
  },
  computed:  {
    ...mapGetters({
      sortingParam: 'GET_SORTING',
      loading: 'GET_LOADING_STATE'
    }),
    // set sortParam depending on value kept in store
    sortParam: {
      get: function() {
        return this.sortingParam
      },
      set: function(value) {
        return value
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// SortDropdown.vue?5b042936